<template>
  <svg viewBox="0 0 10 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="16.6667" width="10" height="33.3333" rx="5" fill="currentColor" />
    <circle cx="5" cy="5" r="5" fill="currentColor" />
  </svg>
</template>

<script>
export default { name: 'info' }
</script>
